import { render } from "./GoodSurveys.vue?vue&type=template&id=9aef562a&scoped=true"
import script from "./GoodSurveys.vue?vue&type=script&lang=js"
export * from "./GoodSurveys.vue?vue&type=script&lang=js"

import "./GoodSurveys.vue?vue&type=style&index=0&id=9aef562a&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aef562a"]])

export default __exports__